import { Box, Button, Paper, Typography } from "@mui/material";
import React, { useState } from "react";
import issue from "../../../assets/svg/issue.svg";
import DataTableComponent from "../../../components/common/DataTable/DataTable";
import { generateOrderColumns } from "../helper";
import SimpleBar from "simplebar-react";

const orderdata = [
  {
    id: 1,
    order_id: 453451,
    created_on: "5/27/2024",
    customer: "Thaddus Morrice",
    total: "1656",
    payment: "Paid",
    fulfilment: "Picking Up",
  },
  {
    id: 2,
    order_id: 534532,
    created_on: "2/13/2024",
    customer: "Cordie Pilsbury",
    total: "1",
    payment: "Pending",
    fulfilment: "Packing",
  },
  {
    id: 3,
    order_id: 657653,
    created_on: "7/28/2024",
    customer: "Gwenneth Folger",
    total: "488",
    payment: "Paid",
    fulfilment: "Deliverry",
  },
  {
    id: 4,
    order_id: 786784,
    created_on: "4/6/2024",
    customer: "Emilee Roose",
    total: "5",
    payment: "Pending",
    fulfilment: "Done",
  },
  {
    id: 5,
    order_id: 867867,
    created_on: "6/6/2024",
    customer: "Theodora Ferrarese",
    total: "8",
    payment: "Paid",
    fulfilment: "Picking Up",
  },
  {
    id: 6,
    order_id: 657867,
    created_on: "1/19/2024",
    customer: "Arlyn Tooby",
    total: "07429",
    payment: "Pending",
    fulfilment: "Packing",
  },
  {
    id: 7,
    order_id: 245247,
    created_on: "2/19/2024",
    customer: "Agnesse Kalisz",
    total: "4",
    payment: "Paid",
    fulfilment: "Deliverry",
  },
  {
    id: 8,
    order_id: 334528,
    created_on: "2/15/2024",
    customer: "Elden Boyington",
    total: "1",
    payment: "Pending",
    fulfilment: "Done",
  },
  {
    id: 9,
    order_id: 757579,
    created_on: "8/26/2024",
    customer: "Carmelle Borrell",
    total: "1349",
    payment: "Paid",
    fulfilment: "Packing",
  },
  {
    id: 10,
    order_id: 245274,
    created_on: "7/3/2024",
    customer: "Baird Stiffell",
    total: "71887",
    payment: "Pending",
    fulfilment: "Done",
  },
];

function OrderList() {
  const [searchValue, setSearchValue] = useState("");

  const storeColumns = generateOrderColumns();

  const filteredRows = orderdata?.filter((row) => {
    const includesTerm = row.customer
      .toLowerCase()
      .includes(searchValue.toLowerCase());
    return includesTerm;
  });
  return (
    <>
      {orderdata?.length > 0 && (
        <SimpleBar
          forceVisible="x"
          autoHide={true}
          style={{
            overflowX: "auto",
            maxHeight: "73vh",
          }}
          className="custom-scrollbar"
        >
          <Box sx={{ display: "contents" }}>
            <Paper
              sx={{
                width: "100%",
                height: "73vh",
                border: "1px solid #E5E5E8",
                borderRadius: "4px",
              }}
            >
              <DataTableComponent
                data={orderdata || []}
                columns={storeColumns}
              />
            </Paper>
          </Box>
        </SimpleBar>
      )}
      {orderdata && orderdata.length <= 0 && (
        <Box sx={{ marginTop: "10%" }}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <img src={issue} alt="issue_not_found" />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "30px",
            }}
          >
            <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
              No records found
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
}

export default OrderList;
